import React, { FC } from 'react';
import { Controller, UseFormGetValues } from 'react-hook-form';
import { FormControl } from '@fiverr-private/orca';
import { translate as t } from '@fiverr-private/i18n-react';
import IndustriesSelect from '@fiverr-private/industries_select';
import { T_FORM_KEY } from '../../utils';
import { FieldComponentProps, WorkExperienceFormType } from '../../shared/types';

import { comboBoxStyle } from '../../shared/styles.ve.css';
import { CompanyStatus } from '../../../../gql-operations/gql-generated';

interface IndustryFieldProps extends FieldComponentProps {
    getValues: UseFormGetValues<WorkExperienceFormType>;
}

const IndustryField: FC<IndustryFieldProps> = ({ control, getValues }) => {
    const isCompanyVerified = getValues().company?.status === CompanyStatus.Approved;
    const verifiedCompanyIndustry = isCompanyVerified && getValues().company?.industry;

    return (
        <FormControl label={t(`${T_FORM_KEY}.fields.industry.label`)} isOptional>
            <Controller
                name="industry"
                control={control}
                render={({ field: { onChange, value, name } }) => (
                    <IndustriesSelect
                        id={name}
                        className={comboBoxStyle}
                        name="industry"
                        placeholder={t(`${T_FORM_KEY}.fields.industry.placeholder`)}
                        isMulti={false}
                        menuShouldBlockScroll
                        onChange={(options) => {
                            onChange((options as { label: string; value: any }).label);
                        }}
                        isDisabled={isCompanyVerified}
                        value={verifiedCompanyIndustry || value}
                        menuPlacement="top"
                        shouldAcceptCustomValues
                    />
                )}
            />
        </FormControl>
    );
};

export default IndustryField;
